// extracted by mini-css-extract-plugin
export var eligibilityCardEligible = "_47-0";
export var eligibilityCardNotEligible = "_47-1";